import { COLLECTION_VIEWS, type CollectionView } from '@witmetrics/unison-core';
import { useLocalStorage } from '@/hooks/useStorage';

export function useCollectionViewSettings(initialView?: CollectionView) {
  return useLocalStorage(
    'collectionViewSettings',
    initialView || COLLECTION_VIEWS.LIST,
    true
  );
}
